// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__B-3rM","footer":"ModalCreateQualiphyProcedure_footer__2QXFX","additionData":"ModalCreateQualiphyProcedure_additionData__18R9i"};